const font = {
  default: ['Poppins', 'Roboto', 'Open Sans', 'sans-serif'],
  bold: '800',
  regular: '400',
}

export default font
